import React from 'react';
import { Phone, PhoneIncoming as PhoneIncomingIcon, X, Minimize2, Maximize2, Circle } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { formatDuration } from './formatDuration';

const FLOATING_STYLE = {
  incoming: 'bg-green-500 animate-bounce shadow-green-200',
  active: 'bg-red-600 shadow-red-200',
};

export function SoftPhoneFloatingButton({ view, onToggle }) {
  return (
    <button
      data-testid="softphone-toggle-btn"
      onClick={onToggle}
      className={`fixed bottom-6 right-6 z-50 w-14 h-14 rounded-full shadow-xl flex items-center justify-center transition-all duration-300 hover:scale-110 ${FLOATING_STYLE[view] || 'bg-slate-800 hover:bg-slate-700'}`}
    >
      {view === 'incoming'
        ? <PhoneIncomingIcon className="w-6 h-6 text-white" />
        : <Phone className={`w-6 h-6 text-white ${view === 'active' ? 'animate-pulse' : ''}`} />}
      {view === 'incoming' && <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full animate-ping" />}
    </button>
  );
}

export function SoftPhoneMinimizedBar({ view, name, duration, isRecording, onExpand }) {
  return (
    <div data-testid="softphone-minimized-bar"
      className="fixed bottom-24 right-6 z-50 bg-slate-900 text-white rounded-xl px-4 py-2.5 shadow-2xl flex items-center gap-3 cursor-pointer border border-slate-700"
      onClick={onExpand}>
      <div className={`w-2.5 h-2.5 rounded-full animate-pulse ${view === 'active' ? 'bg-green-400' : 'bg-amber-400'}`} />
      <span className="text-sm font-medium">{name}</span>
      <span className="text-sm font-mono text-slate-300">{formatDuration(duration)}</span>
      {isRecording && <Circle className="w-3 h-3 fill-red-500 text-red-500 animate-pulse" />}
      <Maximize2 className="w-4 h-4 text-slate-400" />
    </div>
  );
}

export function SoftPhoneHeader({ view, isRecording, onMinimize, onClose }) {
  const inCall = view === 'active' || view === 'ringing';
  return (
    <div className="flex items-center justify-between px-4 py-3 bg-slate-800/80 border-b border-slate-700/50">
      <div className="flex items-center gap-2">
        <Phone className="w-4 h-4 text-red-500" />
        <span className="text-sm font-semibold text-white">Softphone</span>
        {view === 'active' && <Badge className="bg-green-600 text-white text-[10px] px-1.5 py-0">En cours</Badge>}
        {isRecording && <Badge className="bg-red-600 text-white text-[10px] px-1.5 py-0 animate-pulse">REC</Badge>}
      </div>
      <div className="flex items-center gap-1">
        {inCall && (
          <button onClick={onMinimize} className="p-1 text-slate-400 hover:text-white"><Minimize2 className="w-4 h-4" /></button>
        )}
        <button data-testid="softphone-close-btn" onClick={onClose} className="p-1 text-slate-400 hover:text-white">
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
